import { FiShoppingCart, FiArrowRight, FiTrash2 } from "react-icons/fi";

// ✅ UPDATED: Accept sampleCart prop to show unpaid breakdown
const SampleCartBar = ({ cartCount, totalAmount, onProceed, onClearCart, loading, sampleCart }) => {
  // ✅ NEW: Calculate unpaid amount only
  const unpaidAmount = sampleCart
    ? sampleCart.finalCartAmount - sampleCart.paidAmount
    : totalAmount;

  const paidCount = sampleCart?.items?.filter((item) => item.isPaid).length || 0;
  const unpaidCount = sampleCart
    ? (sampleCart.items?.length || 0) - paidCount
    : cartCount;

  // ✅ NEW: Hide bar if no unpaid items
  if (!unpaidCount || unpaidCount === 0) return null;

  const formatPrice = (num) => {
    const n = Number(num || 0);
    if (isNaN(n)) return "0";
    return n % 1 !== 0
      ? n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : n.toLocaleString("en-IN");
  };

  return (
    <>
      {/* ── Desktop bar (bottom of right panel, sticky) ───────────────────── */}
      <div className="hidden md:block mb-3">
        <div className="sticky bottom-0 left-0 right-0 z-30 mt-4">
          <div className="bg-white border border-primaryColor/20 rounded-2xl shadow-xl shadow-primaryColor/10 px-5 py-4 flex items-center justify-between gap-4">
            {/* Left: cart info */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-primaryColor/10 flex items-center justify-center flex-shrink-0">
                <FiShoppingCart className="text-primaryColor text-lg" />
              </div>
              <div>
                <p className="text-sm font-bold text-gray-900">
                  {/* ✅ UPDATED: Show unpaid count, with paid count in parentheses */}
                  {unpaidCount} quotation{unpaidCount > 1 ? "s" : ""} pending payment
                  {paidCount > 0 && (
                    <span className="text-xs text-gray-400 ml-1.5">
                      ({paidCount} already paid)
                    </span>
                  )}
                </p>
                {unpaidAmount > 0 && (
                  <p className="text-xs text-gray-500">
                    {/* ✅ UPDATED: Show unpaid amount only */}
                    Due: ₹{formatPrice(unpaidAmount)}{" "}
                    {paidCount > 0 && (
                      <span className="text-[10px] text-gray-400">
                        (Paid: ₹{formatPrice(sampleCart.paidAmount)})
                      </span>
                    )}
                  </p>
                )}
              </div>
            </div>

            {/* Right: actions */}
            <div className="flex items-center gap-2">
              {onClearCart && (
                <button
                  onClick={onClearCart}
                  disabled={loading}
                  className="flex items-center gap-1.5 px-3 py-2 border border-red-200 text-red-600 rounded-xl text-xs font-semibold hover:bg-red-50 transition-colors disabled:opacity-50"
                >
                  <FiTrash2 className="text-xs" />
                  Clear
                </button>
              )}
              <button
                onClick={onProceed}
                disabled={loading || unpaidCount === 0}
                className="flex items-center gap-2 px-5 py-2.5 bg-primaryColor hover:bg-primaryBtnHoverColor text-white rounded-xl text-sm font-bold transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Processing...
                  </>
                ) : (
                  <>
                    {/* ✅ UPDATED: Show button text with unpaid count */}
                    Proceed to Sample Request ({unpaidCount})
                    <FiArrowRight />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Mobile bar (fixed bottom, above nav) ──────────────────────────── */}
      <div className="md:hidden mb-3">
        <div className="fixed bottom-16 left-0 right-0 z-40 px-4">
          <div className="bg-white border border-primaryColor/30 rounded-2xl shadow-2xl shadow-primaryColor/20 px-4 py-3 flex items-center justify-between gap-3">
            {/* Left: count */}
            <div className="flex items-center gap-2 flex-shrink-0">
              <div className="relative">
                <FiShoppingCart className="text-primaryColor text-xl" />
                {/* ✅ UPDATED: Show unpaid count badge */}
                <span className="absolute -top-1.5 -right-1.5 w-4 h-4 bg-primaryColor text-white text-[9px] font-bold rounded-full flex items-center justify-center">
                  {unpaidCount}
                </span>
              </div>
              <div>
                <p className="text-xs font-bold text-gray-900 leading-tight">
                  {/* ✅ UPDATED: Show unpaid count */}
                  {unpaidCount} Pending
                </p>
                {unpaidAmount > 0 && (
                  <p className="text-[10px] text-gray-400">
                    {/* ✅ UPDATED: Show unpaid amount */}
                    ₹{formatPrice(unpaidAmount)}
                  </p>
                )}
              </div>
            </div>

            {/* Right: proceed */}
            <button
              onClick={onProceed}
              disabled={loading || unpaidCount === 0}
              className="flex items-center gap-1.5 px-4 py-2.5 bg-primaryColor hover:bg-primaryBtnHoverColor text-white rounded-xl text-xs font-bold transition-colors disabled:opacity-50 flex-shrink-0"
            >
              {loading ? (
                <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <>
                  Proceed
                  <FiArrowRight className="text-xs" />
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SampleCartBar;